module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/katarzyna-dolecka-9ca424d5919f77dff57b50648b128f2d.png";